'use strict';

import VZTcBaseCard from './VZTcBaseCard';

/**
 * @class VZTcPaymentType
 * @extends VZTcBaseCard
 * @description Handles the Teams Calling payment type card with slider functionality
 */
export default class VZTcPaymentType extends VZTcBaseCard {}

if (!window.customElements.get('vz-tc-payment-type')) {
    window.customElements.define('vz-tc-payment-type', VZTcPaymentType);
}
